type NestedJson = { [segment: string]: string | NestedJson };

type PathValue = { path: string[]; value: string };

const toNode = (group: PathValue[]): string | NestedJson => {
  const lastLeafIndex = group.findLastIndex(({ path }) => path.length === 1);

  return lastLeafIndex === group.length - 1
    ? group[lastLeafIndex].value
    : toNestedJson(group.slice(lastLeafIndex + 1).map(({ path, value }) => ({ path: path.slice(1), value })));
};

export const toNestedJson = (entries: PathValue[]): NestedJson =>
  Object.fromEntries(
    Array.from(
      Map.groupBy(entries, ({ path }) => path[0]),
      ([segment, group]) => [segment, toNode(group)],
    ),
  );
